// extracted by mini-css-extract-plugin
export var footer = "_nd-0";
export var inherit = "_nd-1";
export var input = "_nd-2";
export var modalContent = "_nd-3";
export var quillEditor = "_nd-4";
export var subtitle = "_nd-5";